import { render, staticRenderFns } from "./Lucky.vue?vue&type=template&id=1e560354&scoped=true"
import script from "./Lucky.vue?vue&type=script&lang=js"
export * from "./Lucky.vue?vue&type=script&lang=js"
import style0 from "./Lucky.vue?vue&type=style&index=0&id=1e560354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e560354",
  null
  
)

export default component.exports